import Button from "@/ui/Button.tsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import st from "@/styles/UserSidebar.module.scss";
import {CircularProgress} from "@mui/material";
import ChevroneIcon from "@/svg/ChevronIocn.tsx";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";


const OpenScheduleModal = () => {
    const [schedule_loading, set_schedule_loading] = useState<boolean>(false)
    const {t} = useTranslation()
    
    const schedule_loading_handling = (x:boolean) => {
        set_schedule_loading(x)
    }
    
    useEffect(() => {
        eventEmitter.on(CommonClass.CustomEvents.loading_schedule, schedule_loading_handling)
        
        return () => {
            eventEmitter.off(CommonClass.CustomEvents.loading_schedule, schedule_loading_handling)
        }
    }, []);
    
    return (
        <Button
            onClick={() => {
                eventEmitter.emit(CommonClass.CustomEvents.open_schedule)
            }}
            disabled={schedule_loading}
            className={st.schedule_btn}
            gray
        >
            {t("reimbursement_schedule")} {schedule_loading ? <CircularProgress color={"success"} size={24}/> : <ChevroneIcon/>}
        </Button>
    )
}

export default OpenScheduleModal